export default function Next({ color }) {
  return (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1L7.29289 7.29289C7.68342 7.68342 7.68342 8.31658 7.29289 8.70711L1 15"
        stroke="#000D5B"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
